// free energy drink — theme JS. Vanilla (no framework), mirrors the React
// site's core interactions: scroll progress, reveal-on-scroll, mobile nav,
// announcement rotator, and a cart drawer wired to Shopify's Ajax Cart API.

document.addEventListener("DOMContentLoaded", () => {
  initProgressBar();
  initReveals();
  initMobileNav();
  initAnnouncement();
  initCart();
  initGalleryCarousel();
  initShopFilters();
  initNightStats();
  initStoryBandFx();
});

function initProgressBar() {
  const bar = document.getElementById("scrollProgress");
  if (!bar) return;
  function onScroll() {
    const doc = document.documentElement;
    const max = doc.scrollHeight - doc.clientHeight;
    bar.style.width = max > 0 ? (doc.scrollTop / max) * 100 + "%" : "0%";
  }
  document.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}

function initReveals() {
  const els = document.querySelectorAll(".reveal");
  if (!els.length) return;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.16 }
  );
  els.forEach((el) => io.observe(el));
}

function initMobileNav() {
  const btn = document.getElementById("menuBtn");
  const panel = document.getElementById("mobileNav");
  if (!btn || !panel) return;
  btn.addEventListener("click", () => {
    const open = panel.classList.toggle("open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  });
}

function initAnnouncement() {
  const track = document.getElementById("annoTrack");
  if (!track) return;
  const spans = track.querySelectorAll("span");
  if (!spans.length) return;
  let i = 0;
  spans[0].classList.add("on");
  setInterval(() => {
    spans[i].classList.remove("on");
    i = (i + 1) % spans.length;
    spans[i].classList.add("on");
  }, 4000);
}

// ---- cart (Shopify Ajax Cart API — no app/backend required) ----

function initCart() {
  const drawer = document.getElementById("cartDrawer");
  const overlay = document.getElementById("cartOverlay");
  const openBtns = document.querySelectorAll("[data-cart-open]");
  const closeBtns = document.querySelectorAll("[data-cart-close]");

  function openDrawer() {
    drawer?.classList.add("open");
    overlay?.classList.add("open");
    refreshCart();
  }
  function closeDrawer() {
    drawer?.classList.remove("open");
    overlay?.classList.remove("open");
  }
  openBtns.forEach((b) => b.addEventListener("click", openDrawer));
  closeBtns.forEach((b) => b.addEventListener("click", closeDrawer));
  overlay?.addEventListener("click", closeDrawer);

  // add-to-cart buttons: <button data-add-to-cart data-variant-id="123">
  document.querySelectorAll("[data-add-to-cart]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const variantId = btn.getAttribute("data-variant-id");
      const qtyTarget = btn.getAttribute("data-qty-target");
      const qtyInput = qtyTarget ? document.querySelector(qtyTarget) : null;
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      btn.disabled = true;
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        if (!res.ok) throw new Error("add_failed");
        showToast("added to cart");
        openDrawer();
      } catch {
        showToast("couldn't add to cart — try again");
      } finally {
        btn.disabled = false;
      }
    });
  });

  refreshCartBadge();
}

async function refreshCart() {
  const linesEl = document.getElementById("cartLines");
  const totEl = document.getElementById("cartTotal");
  if (!linesEl) return;
  const res = await fetch("/cart.js");
  const cart = await res.json();

  linesEl.innerHTML = cart.items.length
    ? cart.items
        .map(
          (item) => `
      <div class="cart-line">
        <img src="${item.image}" alt="${item.product_title}">
        <div style="flex:1">
          <div style="font-size:13.5px;font-weight:600">${item.product_title}</div>
          <div style="font-size:12px;color:var(--body)">${item.variant_title || ""} · qty ${item.quantity}</div>
        </div>
        <div style="font-size:13px;font-weight:600">${formatMoney(item.final_line_price)}</div>
      </div>`
        )
        .join("")
    : `<p style="color:var(--body);font-size:13.5px;">Your cart is empty.</p>`;

  if (totEl) totEl.textContent = formatMoney(cart.total_price);
  refreshCartBadge(cart);
}

async function refreshCartBadge(cartArg) {
  const badge = document.getElementById("cartBadge");
  if (!badge) return;
  const cart = cartArg || (await (await fetch("/cart.js")).json());
  badge.textContent = cart.item_count;
  badge.style.display = cart.item_count > 0 ? "grid" : "none";
}

function formatMoney(cents) {
  return "$" + (cents / 100).toFixed(2);
}

// ---- toast ----

function showToast(msg) {
  let el = document.getElementById("toast");
  if (!el) return;
  el.textContent = msg;
  el.classList.add("show");
  clearTimeout(el._t);
  el._t = setTimeout(() => el.classList.remove("show"), 2600);
}

// ---- shop the range: category filter + sort ----
// Mirrors Shop.jsx: pill filters (all/singles/multipacks/bulk/available now)
// and a sort dropdown (featured/value/low/high), applied client-side over the
// server-rendered cards so no page reload is needed.

function initShopFilters() {
  const grid = document.getElementById("shopGrid");
  const pills = document.querySelectorAll("#shop .pill");
  const sortSelect = document.getElementById("shopSort");
  if (!grid || !pills.length) return;

  const originalOrder = Array.from(grid.querySelectorAll(".card"));
  let filter = "all";

  function applyFilter() {
    grid.querySelectorAll(".card").forEach((card) => {
      const cat = card.getAttribute("data-cat");
      const available = card.getAttribute("data-available") === "true";
      const show =
        filter === "all" ||
        (filter === "available now" ? available : cat === filter);
      card.style.display = show ? "" : "none";
    });
  }

  function applySort() {
    const value = sortSelect ? sortSelect.value : "featured";
    let cards = Array.from(grid.querySelectorAll(".card"));
    if (value === "featured") {
      cards = originalOrder.slice();
    } else if (value === "low") {
      cards.sort((a, b) => Number(a.getAttribute("data-price")) - Number(b.getAttribute("data-price")));
    } else if (value === "high") {
      cards.sort((a, b) => Number(b.getAttribute("data-price")) - Number(a.getAttribute("data-price")));
    } else if (value === "value") {
      cards.sort((a, b) => Number(a.getAttribute("data-percan")) - Number(b.getAttribute("data-percan")));
    }
    cards.forEach((card) => grid.appendChild(card));
  }

  pills.forEach((pill) => {
    pill.addEventListener("click", () => {
      pills.forEach((p) => p.classList.remove("on"));
      pill.classList.add("on");
      filter = pill.getAttribute("data-filter");
      applyFilter();
    });
  });

  if (sortSelect) sortSelect.addEventListener("change", applySort);

  document.querySelectorAll("[data-notify-me]").forEach((btn) => {
    btn.addEventListener("click", () => {
      showToast("we'll let you know when " + btn.getAttribute("data-product-title") + " lands");
    });
  });
}

// ---- story band: scroll-driven grayscale → colour reveal ----
// Mirrors StoryBand.jsx: the photo starts desaturated/slightly zoomed and
// resolves to full colour as it scrolls through a window starting 15% down
// the viewport and finishing 65% of a viewport-height later.

function initStoryBandFx() {
  const pic = document.querySelector(".band .pic");
  const img = pic ? pic.querySelector("img") : null;
  if (!pic || !img) return;

  function update() {
    const vh = window.innerHeight;
    const r = pic.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) {
      const prog = Math.max(0, Math.min(1, 1 - (r.top - vh * 0.15) / (vh * 0.65)));
      img.style.filter = "grayscale(" + (1 - prog) + ") contrast(" + (1.05 - prog * 0.05) + ")";
      img.style.transform = "scale(" + (1.06 - prog * 0.06) + ")";
    }
  }
  document.addEventListener("scroll", update, { passive: true });
  update();
}

// ---- night out: animated stat counters + event photo swap ----

function initNightStats() {
  const stats = document.querySelectorAll(".bigstat[data-count]");
  if (stats.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          const el = entry.target;
          const target = Number(el.getAttribute("data-count"));
          const prefix = el.getAttribute("data-prefix") || "";
          const suffix = el.getAttribute("data-suffix") || "";
          const b = el.querySelector("b");
          const duration = 1200;
          const t0 = performance.now();
          function tick(now) {
            const p = Math.min((now - t0) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            b.textContent = prefix + Math.round(target * eased) + suffix;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.5 }
    );
    stats.forEach((el) => io.observe(el));
  }

  const events = document.querySelectorAll("#nightEvents li");
  const pics = document.querySelectorAll("#nightEvPic img");
  if (events.length && pics.length) {
    events.forEach((li) => {
      li.addEventListener("mouseenter", () => {
        const idx = li.getAttribute("data-idx");
        pics.forEach((img) => img.classList.toggle("on", img.getAttribute("data-idx") === idx));
      });
    });
  }
}

// ---- gallery carousel + lightbox ----
// Track scrolls via CSS animation (pauses on hover); videos are lazily
// loaded and viewport-gated for playback via IntersectionObserver, mirroring
// the React Gallery/VideoTile components.

function initGalleryCarousel() {
  const tiles = document.querySelectorAll("#galleryTrack .car-tile");
  if (!tiles.length) return;

  const videoIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target.querySelector("video");
        if (!video) return;
        if (entry.isIntersecting) {
          if (!video.src) video.src = entry.target.getAttribute("data-src");
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    { rootMargin: "300px" }
  );
  tiles.forEach((tile) => {
    if (tile.getAttribute("data-type") === "video") videoIo.observe(tile);
  });

  const items = [];
  tiles.forEach((tile) => {
    const idx = Number(tile.getAttribute("data-idx"));
    if (items[idx]) return;
    items[idx] = {
      type: tile.getAttribute("data-type"),
      src: tile.getAttribute("data-src"),
      poster: tile.getAttribute("data-poster") || "",
      full: tile.getAttribute("data-full") || "",
    };
  });

  const lb = document.getElementById("galleryLightbox");
  const media = document.getElementById("galleryLightboxMedia");
  if (!lb || !media) return;
  let current = 0;

  function render() {
    const item = items[current];
    if (!item) return;
    media.innerHTML =
      item.type === "video"
        ? `<video src="${item.src}" poster="${item.poster}" controls autoplay playsinline></video>`
        : `<img src="${item.full || item.src}" alt="">`;
  }
  function open(idx) {
    current = idx;
    render();
    lb.hidden = false;
  }
  function close() {
    lb.hidden = true;
    media.innerHTML = "";
  }
  function step(delta) {
    current = (current + delta + items.length) % items.length;
    render();
  }

  tiles.forEach((tile) => {
    const idx = Number(tile.getAttribute("data-idx"));
    tile.addEventListener("click", () => open(idx));
    tile.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        open(idx);
      }
    });
  });

  lb.querySelector("[data-lb-close]").addEventListener("click", close);
  lb.querySelector("[data-lb-prev]").addEventListener("click", () => step(-1));
  lb.querySelector("[data-lb-next]").addEventListener("click", () => step(1));
  lb.addEventListener("click", (e) => {
    if (e.target === lb) close();
  });
  document.addEventListener("keydown", (e) => {
    if (lb.hidden) return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowRight") step(1);
    if (e.key === "ArrowLeft") step(-1);
  });
}
